<template>
  <div>
    <table>
      <thead>
      <tr>
        <th v-for="(item, i) in headers" :key="i" :class="getColumnClass(item.field)">
          <template v-if="item.visible">
            {{ item.name }}
          </template>
        </th>
      </tr>
      </thead>
      <tbody v-if="organisationUsers.length">
      <template v-for="user in organisationUsers" :key="user.id">
        <tr>
          <td class="icon-column">
            <svg height="1em" viewBox="0 0 384 512">
              <user />
            </svg>
          </td>
          <td>
            <router-link :to="orgUrl + '/anvandare/' + user.id"> {{ user.firstName }} {{ user.lastName }}</router-link>
            <TextBadge v-if="user.isHeadContact" :text="labels.headContact"></TextBadge>
            <TextBadge v-if="user.isDSResponsible" :text="labels.dsResponsible"></TextBadge>
          </td>
          <td class="status-column">
            {{ getOrgUserStatusText(user.status) }}
          </td>
        </tr>
      </template>
      </tbody>
    </table>
    <div v-if="!organisationUsers.length" class="container">
      <p>Inga organisationsadministratörer kunde hittas</p>
    </div>
  </div>
</template>


<script lang="ts">
import { defineComponent } from "@vue/runtime-core";
import { useRoute } from "vue-router";
import Symbol from "./Symbol.vue";
import TextBadge from "./TextBadge.vue";
import { storeToRefs } from "pinia";
import { useOrganisationUsersStore } from "@/stores/organisationUsers";
import user from "@/components/svg/user.vue";
import { TableHeader } from "@/static/types/TableHeader";
import { getColumnClass } from "@/helper/getColumnClass";

enum Labels {
  headContact = "Huvudkontakt",
  pubResponsible = "PUB-avtalsansvarig",
  dsResponsible = "Digitala samlingen"
}

export default defineComponent({
  components: {
    Symbol,
    TextBadge,
    user
  },
  name: "TableAdministrators",

  setup() {
    const labels = Labels;
    const headers: TableHeader[] = [
      {
        field: "id",
        name: "Id",
        visible: false
      },
      {
        field: "name",
        name: "Namn",
        visible: true
      },
      {
        field: "status",
        name: "Status",
        visible: true
      }
    ];

    const route = useRoute();
    const orgUrl = `/organisation/${route.params.orgId}`;
    const organisationUsersStore = useOrganisationUsersStore();
    const { organisationUsers } = storeToRefs(organisationUsersStore);

    const getOrgUserStatusText = (status: "Inactive" | "Active" | "Removed" | "Invited" | ""): string => {
      switch (status) {
        case "Inactive":
          return "Inaktiv";
        case "Active":
          return "Aktiv";
        case "Removed":
          return "Borttagen";
        case "Invited":
          return "Inbjuden";
        default:
          return "";
      }
    };

    return {
      orgUrl,
      getOrgUserStatusText,
      getColumnClass,
      headers,
      labels,
      organisationUsers
    };
  }
});

</script>

<style lang="scss">
@import '../assets/table.scss';
</style>
